import _ from "lodash"
import { jwtDecode } from "jwt-decode"
//import http from "../http_helper"
import {
  del,
  get,
  post,
  postReturnHeaders,
  put,
  setJwtAuthToken,
} from "../api_helper"
import { node } from "../../config.js"
import {
  fnConvertUTCToString,
  fnDateTimeFromSql,
  getCurrentTime,
  fnGetDateDiff,
  fnGetDateTime,
  decrypt,
  encrypt,
} from "../../common/global/functions.js"

const baseUrl =
  process.env.REACT_APP_PRODUCTION === "prod"
    ? node.baseUrl
    : process.env.REACT_APP_PRODUCTION === "stage"
    ? node.stageUrl
    : node.devUrl
const tokenKey = "token"
const session = "session"
const authUser = "authUser"
const sessionExpire = "sessionExpire"
const sessionTimeout = "sessionTimeout"

function sleep(delay) {
  var start = new Date().getTime()
  while (new Date().getTime() < start + delay);
}

export async function loginConsoleAuth(credentials) {
  
  try {
    logout();
    let authUrl = baseUrl + node.auth.console.url

    let response = await postReturnHeaders(authUrl, {
      code: credentials.code,
      pin: credentials.pin,
    })

    return response
  } catch (ex) {
    var message =
      _.has(ex, "response") &&
      ex.response.status !== 200 &&
      _.has(ex.response, "data")
        ? ex.response.data
        : ex.message
    throw new Error(message)
  }
}

export async function loginSignUpUrlAuth({identifier}) {
  
  try {
    logout()
    let authUrl = baseUrl + node.auth.signup.url

    let response = await postReturnHeaders(authUrl, {identifier})

    return response
  } catch (ex) {
    var message =
      _.has(ex, "response") &&
      ex.response.status !== 200 &&
      _.has(ex.response, "data")
        ? ex.response.data
        : ex.message
    throw new Error(message)
  }
}

export async function loginCoSignUpUrlAuth({url_identifier}) {
  
  try {
    logout()
    let authUrl = baseUrl + node.auth.cosignup.url

    let response = await postReturnHeaders(authUrl, {url_identifier})

    return response
  } catch (ex) {
    var message =
      _.has(ex, "response") &&
      ex.response.status !== 200 &&
      _.has(ex.response, "data")
        ? ex.response.data
        : ex.message
    throw new Error(message)
  }
}

export function loginWithJwt(jwt) {
  sessionStorage.setItem(tokenKey, jwt)
}

export function logout() {
  sessionStorage.removeItem(tokenKey)
  sessionStorage.removeItem(authUser)
  sessionStorage.removeItem(session)
}

export function resetCoApp() {
  let session = getSession()

  delete session.app["coapplicant"]
  session.app["applicant"]["jointapplicationid"] = null

  setSession(session)

  return getSession()
}

export function reset(user) {
  let s = getSession()

  if (_.has(s, "app")) s["app"] = {}

  if (_.has(s, "pagetracker")) delete s["pagetracker"]

  setSession(s)

  return getSession()
}

export function getJwt() {
  return sessionStorage.getItem(tokenKey)
}

export const getCurrentUser = () =>
  sessionStorage.getItem(authUser)
    ? JSON.parse(sessionStorage.getItem(authUser))
    : null

export const setCurrentUser = ({ expires, originalMaxAge }) => {
  let user = {
    ...jwtDecode(getJwt()),
    expires: fnConvertUTCToString(expires),
  }
  sessionStorage.setItem(authUser, JSON.stringify(user))
  sessionStorage.setItem(sessionExpire, fnConvertUTCToString(expires))
  sessionStorage.setItem(
    sessionTimeout,
    fnGetDateTime(fnConvertUTCToString(expires)).toMillis() -
      fnGetDateTime(getCurrentTime()).toMillis()
  )
}

const setSessionExpire = ({ expires }) =>
  sessionStorage.setItem(sessionExpire, fnDateTimeFromSql(expires))

export const getSessionExpire = () => sessionStorage.getItem(sessionExpire)
export const getSessionTimeout = () => sessionStorage.getItem(sessionTimeout)

export function setJwt(jwt) {
  sessionStorage.setItem(tokenKey, jwt)
  setJwtAuthToken(jwt)
}

export function setSession(s) {
  if (sessionStorage.getItem(session)) sessionStorage.removeItem(session)

  sessionStorage.setItem(session, encrypt(JSON.stringify(s)))
}

export function getSession() {
  return sessionStorage.getItem(session)
    ? JSON.parse(decrypt(sessionStorage.getItem(session)))
    : null
}

export function getUsername() {
  let { merchant } = getSession()
  return merchant
    ? merchant.first_name
      ? merchant.first_name + " " + merchant.last_name
      : merchant.contactFirst
      ? merchant.contactFirst + " " + merchant.contactLast
      : merchant.seller_title
    : null
}
